﻿/**
* DevExpress Analytics (query-builder\dataSource\dbTable.js)
* Version:  21.2.7
* Build date: Apr 13, 2022
* Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dbColumn_1 = require("./dbColumn");
var dbForeignKey_1 = require("./dbForeignKey");
var _dbSchema_1 = require("./_dbSchema");
var DBTable = (function () {
    function DBTable(model) {
        this.name = model['Name'];
        this.isView = model['IsView'] === 'true' || model['IsView'] === true;
        this.columns = _dbSchema_1.deserializeToCollection(model['columns'], function (columnModel) { return new dbColumn_1.DBColumn(columnModel); });
        this.foreignKeys = _dbSchema_1.deserializeToCollection(model['foreignKeys'], function (columnModel) { return new dbForeignKey_1.DBForeignKey(columnModel); });
    }
    return DBTable;
}());
exports.DBTable = DBTable;
